const Discussion = (): JSX.Element => (
  <svg
    width="23px"
    height="23px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.783.87a2.855 2.855 0 0 0-2.855 2.855V6.71a2.855 2.855 0 0 0 2.855 2.855h11.761A2.855 2.855 0 0 0 21.4 6.71V3.725A2.855 2.855 0 0 0 18.544.87H6.783Zm-.952 2.855c0-.525.426-.951.952-.951h11.761c.526 0 .952.426.952.951V6.71a.952.952 0 0 1-.952.952H6.783a.952.952 0 0 1-.952-.952V3.725ZM3.456 11.168a2.855 2.855 0 0 0-2.855 2.856v3.144a2.855 2.855 0 0 0 2.855 2.855h.613v1.727a.952.952 0 0 0 1.6.696l2.6-2.423h7.046a2.855 2.855 0 0 0 2.855-2.855v-3.144a2.855 2.855 0 0 0-2.855-2.855H3.456Zm-.951 2.856c0-.526.426-.952.951-.952h11.859c.526 0 .952.426.952.952v3.144a.952.952 0 0 1-.952.951H7.519l-1.547 1.442V18.12H3.456a.952.952 0 0 1-.951-.951v-3.144Z"
      fill="currentColor"
    />
  </svg>
);

export default Discussion;
